import { getGlobalSelector } from './mmd';

export const getRoot = () => getGlobalSelector().additionalSelectors.modalSelectors;

export const isTradeInVehicleInfoModalVisible = (state) => getRoot().isTradeInVehicleInfoModalVisible(state);

